import type { AccessibilityProps } from "@-/com.npmjs.react-native";
import { SwipeDownGesture } from "@-/dev.improve.haniverse.components.ui.swipe-down-gesture";
import { useInternalFeatureAccess } from "@-/dev.improve.haniverse.lib.admin.access";
import type { ReactNode } from "react";
import { ToolbarDebugPanel } from "#toolbar-debug-panel";
import { ToolbarExpandingPopover } from "#toolbar-expanding-popover";

const DEBUG_GESTURE_ACTION = {
  hint: "Swipe down to open the debug panel",
  label: "Open debug panel",
  name: "debug",
};

/**
 * Swiping down from a menu button grows the Debug panel out of it, the way a tap grows the menu.
 * Only the menu's touch target owns this gesture; ordinary menu taps pass through.
 */
export function ToolbarDebugGesture({
  children,
  collapsedContent,
}: {
  children: (props: AccessibilityProps) => ReactNode;
  /** The button's glyph or avatar, carried by the panel while it grows out of the button. */
  collapsedContent?: ReactNode;
}) {
  const enabled = useInternalFeatureAccess();
  return (
    <ToolbarExpandingPopover
      collapsedContent={collapsedContent}
      dismissLabel="Dismiss debug panel"
      fill
      headerOutset={4}
      testID="toolbar-debug-panel"
      trigger={({ open }) => (
        <SwipeDownGesture
          action={DEBUG_GESTURE_ACTION}
          enabled={enabled}
          onSwipeDown={open}
          testID="toolbar-debug-gesture"
        >
          {children}
        </SwipeDownGesture>
      )}
    >
      {({ close }) => (enabled ? <ToolbarDebugPanel close={close} /> : null)}
    </ToolbarExpandingPopover>
  );
}
